import React from 'react';
import { Avatar } from '@shoflo/polymer/components/Avatar/Avatar';
import ListItemMenu from './ArchiveListItemMenu';
import EventRowLabelCell from './EventRowLabelCell';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { Label } from '@shoflo/polymer/components/label/Label';
import DefaultImage from 'components/DefaultImage';
import { getFormattedDateFromMillis } from 'utils/time';

import {
  StyledTooltip,
  StyledEventSettings,
  StyledEventDescription,
  StyledEventTitle,
  HideEventLocationXS,
  ShowEventLocationXS,
  PhotoTD,
  TitleTD,
  StyledTD,
  StyledEventPhoto,
} from 'components/event/ListItem';

const ArchiveEventListItem = React.memo(
  ({
    event,
    onRestoreClick,
    onDuplicateClick,
    onDeleteClick,
    onViewClick,
    dateFormat,
  }) => {
    const onRestoreClickHandler = onRestoreClick.bind(this, event);
    const onDuplicateClickHandler = onDuplicateClick.bind(this, event);
    const onDeleteClickHandler = onDeleteClick.bind(this, event);
    const onViewClickHandler = onViewClick.bind(this, event);

    const imgNode = event.photo ? (
      <StyledEventPhoto
        src={event.photo}
        alt={`${event.title} logo`}
        onClick={onViewClickHandler}
      />
    ) : (
      <DefaultImage />
    );

    const eventStartDate = getFormattedDateFromMillis(
      event.startOn,
      dateFormat,
      event.timeZone,
    );
    const eventEndDate = getFormattedDateFromMillis(
      event.endOn,
      dateFormat,
      event.timeZone,
    );
    const eventDate = `${eventStartDate} - ${eventEndDate}`;
    const eventLocation = event.venue && `| ${event.venue}`;

    const listMenuProps = {
      onDelete: onDeleteClickHandler,
    };

    if (event.archived || event.deleted) {
      listMenuProps.onRestore = onRestoreClickHandler;
    } else {
      listMenuProps.onDuplicate = onDuplicateClickHandler;
    }

    return (
      <tr data-testid={`event-${event.title}`}>
        <PhotoTD>{imgNode}</PhotoTD>
        <TitleTD>
          <StyledEventTitle onClick={onViewClickHandler}>
            {event.title}
          </StyledEventTitle>
          <StyledEventDescription>
            <span id={`event_${event._id}`}>
              {eventDate}{' '}
              <HideEventLocationXS>{eventLocation}</HideEventLocationXS>
            </span>
            {eventLocation && (
              <ShowEventLocationXS>
                {eventLocation.replace('| ', '')}{' '}
                <FontAwesomeIcon icon={faMapMarkerAlt} />
              </ShowEventLocationXS>
            )}
          </StyledEventDescription>
          {eventLocation && eventLocation.length >= 25 && (
            <StyledTooltip
              title={`event ${event._id} tooltip`}
              delay={300}
              placement="auto"
              target={`event_${event._id}`}
            >
              {`${eventDate} ${eventLocation}`}
            </StyledTooltip>
          )}
        </TitleTD>
        <StyledTD
          key={`${event._id}-label-wrapper`}
          className="d-none d-lg-table-cell"
        >
          <EventRowLabelCell
            key={`${event._id}-label-cell`}
            labels={event.labels}
            max={2}
            eventId={event._id}
          />
        </StyledTD>
        <StyledTD className="d-none d-lg-table-cell">
          {event.owner && <Avatar key={event.owner._id} user={event.owner} />}
        </StyledTD>
        <StyledEventSettings
          data-testid="eventDropdown"
          className="d-none d-sm-table-cell"
        >
          {(event.archived || event.deleted) && (
            <Label color={'#FFFCBB'} text="Manually Archived" />
          )}
          <ListItemMenu {...listMenuProps} />
        </StyledEventSettings>
      </tr>
    );
  },
);

ArchiveEventListItem.displayName = 'ArchiveEventListItem';

export default ArchiveEventListItem;
